module.exports = "<svg width=\"20\" height=\"11\" viewBox=\"0 0 20 11\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g fill=\"#4A4A4A\">\n    <path d=\"M10 11C4.477 11 0 5.5 0 5.5S4.477 0 10 0s10 5.5 10 5.5S15.523 11 10 11zm0-1.222c2.274 0 4.118-1.915 4.118-4.278 0-2.363-1.844-4.278-4.118-4.278S5.882 3.137 5.882 5.5c0 2.363 1.844 4.278 4.118 4.278z\"/>\n    <ellipse cx=\"10\" cy=\"5.5\" rx=\"2.157\" ry=\"2.241\"/>\n  </g>\n  <path d=\"M4.5 11.045L15.5 0\" stroke=\"#4A4A4A\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/eye-strikethrough.svg
// module id = 794
// module chunks = 1